// extracted by mini-css-extract-plugin
module.exports = {"tabList":"TabList_tabList__3zZC0","tab":"TabList_tab__l4Ims"};